export default __webpack_public_path__ + "static/media/Terms of use.c2255556.pdf";